import { useEffect } from "react";
import { useSettings } from "@/context/AppContext";
import { SITE_URL } from "@/lib/api";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function SEO({ title, description, path = "", image }) {
  const { settings } = useSettings();
  useEffect(() => {
    const t = title || "AnVibes Exports | Spices, Rice & Teas — Bringing Indian Products to Global Markets";
    const d = description || "India-based exporter of premium Indian rice, authentic spices and quality teas for global markets.";
    const raw = image || settings?.seo?.og_image;
    const img = raw && raw.startsWith("/") ? `${SITE_URL}${raw}` : raw;
    document.title = t;
    upsertMeta("name", "description", d);
    upsertMeta("property", "og:title", t);
    upsertMeta("property", "og:description", d);
    upsertMeta("property", "og:url", `${SITE_URL}${path}`);
    upsertMeta("property", "og:image", img);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${SITE_URL}${path || "/"}`);
  }, [title, description, path, image, settings]);
  return null;
}
